<template>
  <div class="home_page" ref="scrollContent" @scroll="onScroll">
    <div class="scroll_view">
      <div
        class=""
        :class="[page.className]"
        v-for="(page, index) in pageConfig"
        :key="index"
      >
        <template v-if="page.className === 'page_1'">
          <pageOne
            ref="pageOne"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
            @showMask="showMask"
          ></pageOne>
        </template>
        <template v-else-if="page.className === 'page_2'">
          <pageTwo
            ref="pageTwo"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
          ></pageTwo>
        </template>
        <template v-else-if="page.className === 'page_3'">
          <pageThree
            ref="pageThree"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
          ></pageThree>
        </template>
        <template v-else-if="page.className === 'page_4'">
          <pageFour
            ref="pageFour"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
          ></pageFour>
        </template>
        <template v-else-if="page.className === 'page_5'">
          <pageFive
            ref="pageFive"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
          ></pageFive>
        </template>
        <template v-else-if="page.className === 'page_6'">
          <pageSix
            ref="pageSix"
            :style="`height:${windowHeight > 720 ? windowHeight : 720}px`"
            :activePageIndex="activeIndex"
            @showMask="showMask"
          ></pageSix>
        </template>
      </div>
    </div>
    <qrcode v-if="showQrcode" @cancleShow="cancleShow"></qrcode>
  </div>
</template>

<script>
export default {
  components: {
    pageOne: () => import("./components/pageOne.vue"),
    pageTwo: () => import("./components/pageTwo.vue"),
    pageThree: () => import("./components/pageThree.vue"),
    pageFour: () => import("./components/pageFour.vue"),
    pageFive: () => import("./components/pageFive.vue"),
    pageSix: () => import("./components/pageSix.vue"),
    qrcode: () => import("./components/qrcode.vue"),
  },
  data() {
    return {
      activeIndex: 0,
      showQrcode: false,
      pageConfig: [
        {
          isHeaderLight: true,
          className: "page_1",
        },
        {
          isHeaderLight: true,
          className: "page_2",
        },
        {
          isHeaderLight: false,
          className: "page_3",
        },
        {
          isHeaderLight: true,
          className: "page_4",
        },
        {
          isHeaderLight: false,
          className: "page_5",
        },
        {
          isHeaderLight: true,
          className: "page_6",
        },
      ],
      windowHeight: 768,
      oneScrollHeight: 0,
      timer: null,
    };
  },
  created() {
    this.getWindowHeight();
  },
  mounted() {},
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiperInstance;
    },
  },
  methods: {
    getWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    goPageBottom() {
      let target = this.$refs.scrollContent.scrollHeight - this.windowHeight;
      let step = 50;
      this.moveSlow(target, step)
    },
    moveSlow(target, step) {
      if (this.$refs.scrollContent.scrollTop < target) {
        this.$refs.scrollContent.scrollTop += step;
        setTimeout(() => {
          if (this.$refs.scrollContent.scrollTop < target) {
            this.moveSlow(target, step);
          } else {
            this.$refs.scrollContent.scrollTop = target
          }
        }, 1)
      } else {
        this.$refs.scrollContent.scrollTop = target
      }
    },
    onScroll(e) {
      let scrollHeight = e.target.scrollTop;
      let pageIndex = Math.floor(scrollHeight / this.windowHeight);
      this.activeIndex = pageIndex;
      this.checkHeadStyle()
    },
    cancleShow() {
      this.showQrcode = false;
    },
    showMask() {
      this.showQrcode = true;
    },
    checkHeadStyle() {
      this.isHeaderLight = this.pageConfig[this.activeIndex].isHeaderLight;
      this.$emit("changeHeadStyle", this.isHeaderLight);
    },
  },
};
</script>

<style lang="less" scoped>
.home_page {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  transition: all .3s;
  .scroll_view {
    min-height: 100%;
    height: auto;
  }
  .page_1 {
    background: linear-gradient(107.73deg, #0174ff 0%, #5500c1 100%);
  }
  .page_2 {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.36), rgba(0, 0, 0, 0.36)),
      linear-gradient(107.73deg, #5500c1 0%, #0174ff 100%);
  }
  .page_3 {
    background: linear-gradient(0deg, #ffffff, #ffffff),
      linear-gradient(107.73deg, #5500c1 0%, #0174ff 100%);
  }
  .page_4 {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
      linear-gradient(107.73deg, #5500c1 0%, #0174ff 100%);
  }
  .page_5 {
    background: #ffffff;
  }
  .page_6 {
    background: linear-gradient(107.73deg, #0174ff 0%, #5500c1 100%);
  }
}
</style>
